import React from "react";
import { Tag, Dropdown, Menu, Button } from "antd";
import { MoreOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import moment from "moment";

const Columns = {};

const renderDataValue = (value) => {
  const style = value ? {} : { color: "#c0c0c0" };
  return <span style={style}>{value || "--"}</span>;
};

Columns.code = {
  dataIndex: "code",
  key: "code",
  title: "#",
  width: 150,
  render: (code) => (
    <Tag color="red" style={{ fontWeight: "bold" }}>
      #{code}
    </Tag>
  ),
};

Columns.title = {
  dataIndex: "title",
  key: "title",
  title: "Tiêu đề voucher",
  width: 200,
  ellipsis: true,
  render: (title) => renderDataValue(title),
};

Columns.condition = {
  dataIndex: "condition",
  key: "condition",
  title: "Điều kiện",
  width: 200,
  ellipsis: true,
  render: (condition) => renderDataValue(condition),
};

Columns.discountValue = {
  key: "discountValue",
  title: "Tỉ lệ khuyến mãi",
  width: 140,
  render: (_, record) => {
    if (record.discountType === "PERCENTAGE") {
      return <span>{record.discountValue}%</span>;
    }
    return (
      <span>
        {record.currency === "JPY" ? "\u00A5" : ""}
        {(record.discountValue || 0).toLocaleString()}
      </span>
    );
  },
};

Columns.dateRange = {
  key: "dateRange",
  title: "Thời gian",
  width: 200,
  render: (_, record) => {
    const start = record.startDate
      ? moment(record.startDate).format("D/M/YYYY")
      : "--";
    const end = record.endDate
      ? moment(record.endDate).format("D/M/YYYY")
      : "--";
    return <span>{`${start} - ${end}`}</span>;
  },
};

Columns.usageDuration = {
  key: "status",
  title: "Trạng thái",
  width: 120,
  render: (_, record) => {
    const now = new Date();
    const endDate = new Date(record.endDate);
    const startDate = new Date(record.startDate);
    if (endDate < now) {
      return <Tag color="red">Hết hạn</Tag>;
    }
    if (startDate > now) {
      return <Tag color="blue">Chưa bắt đầu</Tag>;
    }
    return <Tag color="green">Đang hoạt động</Tag>;
  },
};

Columns.used = {
  key: "usedCount",
  title: "Sử dụng",
  width: 100,
  render: (_, record) => {
    const used = record.usedCount || 0;
    if (used > 0) {
      return <Tag color="green">Đã dùng</Tag>;
    }
    return <Tag>Chưa dùng</Tag>;
  },
};

Columns.description = {
  dataIndex: "description",
  key: "description",
  title: "Nội dung KM",
  width: 300,
  ellipsis: true,
  render: (description) => renderDataValue(description),
};

Columns.actions = (onEdit, onDelete) => ({
  key: "actions",
  width: 60,
  fixed: "right",
  render: (_, record) => {
    const menu = (
      <Menu>
        <Menu.Item key="edit" icon={<EditOutlined />} onClick={() => onEdit(record)}>
          Sửa
        </Menu.Item>
        <Menu.Item key="delete" icon={<DeleteOutlined />} onClick={() => onDelete(record)} danger>
          Xóa
        </Menu.Item>
      </Menu>
    );
    return (
      <Dropdown overlay={menu} trigger={["click"]}>
        <Button type="text" icon={<MoreOutlined />} />
      </Dropdown>
    );
  },
});

export default Columns;
